import * as validator from '@/utilities/Validators';
import { FileType } from '@/utilities/UploaderBase';

export enum ValidatorType {
  Auto = 'Auto',
  Video = 'Video',
  Subtitle = 'Subtitle',
  Image = 'Image',
  Document = 'Document',
  Font = 'Font',
}

export class ValidatorFactory {
  public static validatorFromFileType(type: FileType) {
    switch (type) {
      case FileType.video:
        return new validator.VideoValidator();
        break;
      case FileType.subtitle:
        // return new SubtitleValidator();
        break;
      case FileType.image:
        // return new ImageValidator();
        break;
      case FileType.document:
        // return new DocumentValidator();
        break;
      case FileType.font:
        // return new FontValidator();
        break;
      default:
        console.error('unkonwn file type for validator');
        break;
    }
  }
  public static validatorFromType(type: ValidatorType) {
    switch (type) {
      case ValidatorType.Video:
        // return new VideoValidator();
        break;
      case ValidatorType.Subtitle:
        // return new SubtitleValidator();
        break;
      case ValidatorType.Image:
        // return new ImageValidator();
        break;
      case ValidatorType.Document:
        // return new DocumentValidator();
        break;
      case ValidatorType.Font:
        // return new FontValidator();
        break;
      default:
        //(includes auto)
        console.error('unknown validator type or auto selected');
        break;
    }
  }
}
